let swiperInstance = null; // Track the Swiper instance globally

function InitializeSlider() {
  // Destroy existing Swiper instance if it exists
  if (swiperInstance) {
    swiperInstance.destroy(true, true);
    swiperInstance = null;
  }

  // Only initialize Swiper for mobile (window width <= 768)
  if (window.innerWidth <= 768) {
    const slides = document.querySelectorAll(".swiper-slide");
    let activeIndex = 0;

    // Find the index of the active tag
    slides.forEach((slide, index) => {
      if (slide.classList.contains("inline-nav--active")) {
        activeIndex = index;
      }
    });

    // Initialize new Swiper instance
    swiperInstance = new Swiper(".swiper-container", {
      slidesPerView: 3,
      slidesPerGroup: 1,
      spaceBetween: 10,
      loop: true,
      loopedSlides: slides.length,
      centeredSlides: true,
      initialSlide: activeIndex,
      freeMode: false,
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
        hide: false,
      },
    });
  }
}

function smoothOpacityTransition(element, targetOpacity, duration, callback) {
  let startOpacity = parseFloat(element.style.opacity) || 1;
  let startTime = null;

  function animate(timestamp) {
    if (!startTime) startTime = timestamp;
    const progress = (timestamp - startTime) / duration;
    // Use ease-in-out for smoother start and end
    const easedProgress = Math.min(progress, 1);
    const currentOpacity = startOpacity + (targetOpacity - startOpacity) * easedProgress;

    element.style.opacity = currentOpacity;

    if (progress < 1) {
      requestAnimationFrame(animate);
    } else {
      element.style.opacity = targetOpacity;
      if (callback) callback();
    }
  }

  requestAnimationFrame(animate);
}

function bindNavClick() {
  document.querySelectorAll('.inline-nav li').forEach(btn => {
    if (btn.dataset.listener) return;
    btn.dataset.listener = 'true';
    const bodycss = document.querySelector('body');

    btn.addEventListener('click', (e) => {
      e.preventDefault();
      
      // Smoothly fade out to 0.7
      smoothOpacityTransition(bodycss, 0.7, 300, () => {
        const link = btn.querySelector('a');
        if (!link) {
          smoothOpacityTransition(bodycss, 1, 300); // Reset if no link
          return;
        }

        const page = link.getAttribute('href');
        console.log('Loading page:', page);

        fetch(page)
          .then(res => res.text())
          .then(html => {
            const container = document.querySelector('body');
            container.innerHTML = html;

            // Rebind event listeners
            bindNavClick();

            // Re-execute scripts from the new page
            const scripts = container.querySelectorAll('script');
            scripts.forEach(script => {
              const newScript = document.createElement('script');
              if (script.src) {
                newScript.src = script.src;
              } else {
                newScript.text = script.innerText;
              }
              document.body.appendChild(newScript);
              script.remove();
            });

            // Initialize slider
            InitializeSlider();

            // Update browser history
            history.pushState(null, null, page);

            // Slight delay to ensure rendering is complete before fade-in
            setTimeout(() => {
              smoothOpacityTransition(bodycss, 1, 500); // Longer duration for smoother fade-in
            }, 100); // 100ms delay for rendering
          })
          .catch(err => {
            console.error('Error loading page:', err);
            // Smoothly reset opacity on error
            smoothOpacityTransition(bodycss, 1, 300);
          });
      });
    });
  });
}

// Handle window resize to reinitialize Swiper if needed
window.addEventListener('resize', () => {
  InitializeSlider();
});

// Initial setup
InitializeSlider();
bindNavClick();